import type { IconData } from '@stacksjs/iconify-core'

export const ci4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#00cd00\" d=\"M426.8 0H640v480H426.8z\"/><path fill=\"#ff9a00\" d=\"M0 0h212.9v480H0z\"/><path fill=\"#fff\" d=\"M212.9 0h214v480h-214z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ci4x3
